import React, { forwardRef } from 'react'
import CKEditor from 'ckeditor4-react'

import config from './config'

const TextEditor = forwardRef((_, ref) => <CKEditor ref={ref} config={config} />)

export default TextEditor
